import { HttpStatusCode } from 'axios';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { ERROR_CODES } from '@constants/auth.constants';
import {
  AuthErrorType,
  UseAuthErrorHandlerReturn,
  BASE_HTTP_ERRORS,
  CONTEXT_OVERRIDES,
  AUTH_ERROR_TYPES,
} from './useAuthErrorHandler.types';

const useAuthErrorHandler = (
  type: AuthErrorType = AUTH_ERROR_TYPES.GENERAL
): UseAuthErrorHandlerReturn => {
  const { t } = useTranslation();

  const getErrorMessage = useMemo(
    () =>
      (error: any): string => {
        const status = error.response?.status as HttpStatusCode;

        const contextOverride = CONTEXT_OVERRIDES[type]?.[status];
        if (contextOverride) {
          return t(contextOverride) || '';
        }

        const baseError = BASE_HTTP_ERRORS[status];
        if (baseError) {
          return t(baseError) || '';
        }

        if (
          error.code === ERROR_CODES.NETWORK ||
          error.code === ERROR_CODES.NETWORK_ERROR
        ) {
          return t('errorNetworkConnection') || '';
        }

        return t('errorDefault') || '';
      },
    [t, type]
  );

  return {
    getErrorMessage,
  };
};

export default useAuthErrorHandler;
